<kendo-formfield class="form-field" [formGroup]="formgroup!">
    <kendo-floatinglabel text="Munkaidő">
        <kendo-dropdownlist class="dd" [formControl]="workhoursFC!" [data]="workhours" 
            [defaultItem]="'Összes'" name="workhours" [valuePrimitive]="true"
            [filterable]="false">
        </kendo-dropdownlist>
    </kendo-floatinglabel>
</kendo-formfield>